import { FC } from 'react';
import { BulkActionBar, Icon } from '@getsynapse/design-system';
import { useBulkActions } from './hooks/useBulkActions/useBulkActions';
import { useTasksMetrics } from './hooks/useTasksMetrics/useTasksMetrics';
import BulkAssign from './components/BulkAssign/BulkAssign';
import { BulkDelete } from './components/BulkDelete';
import EditableTasksCountTooltip from './components/EditableTasksCountTooltip/EditableTasksCountTooltip';
import loaderSvg from 'assets/icons/loading.svg';

interface BulkActionsProps {
  bulkTaskAssignFlag: boolean;
  bulkTaskDeleteFlag: boolean;
}

const BulkActions: FC<BulkActionsProps> = ({
  bulkTaskAssignFlag,
  bulkTaskDeleteFlag,
}) => {
  const {
    canBulkAssign,
    canBulkDelete,
    handleCloseBulkActionsBar,
    isBulkActionsBarVisible,
    isBulkOperationInProgress,
  } = useBulkActions({
    bulkTaskAssignFlag,
    bulkTaskDeleteFlag,
  });

  const {
    numberOrRowsSelectedLabel,
    isLoadingTasksMetrics,
    displayEditableTasksCountTooltip,
  } = useTasksMetrics({
    isBulkActionsBarVisible,
  });

  if (!canBulkAssign && !canBulkDelete) {
    return null;
  }

  const actionButtons = [];
  if (canBulkAssign) {
    actionButtons.push(<BulkAssign key='bulk-assign' />);
  }
  if (canBulkDelete) {
    actionButtons.push(
      <BulkDelete disabled={isBulkOperationInProgress} key='bulk-delete' />
    );
  }

  let infoTooltip = undefined;
  if (isLoadingTasksMetrics) {
    infoTooltip = (
      <Icon
        src={loaderSvg}
        className='text-xl animate-spin text-neutral-white'
      />
    );
  } else if (displayEditableTasksCountTooltip) {
    infoTooltip = <EditableTasksCountTooltip />;
  }

  return (
    <BulkActionBar
      isVisible={isBulkActionsBarVisible}
      onCloseCallback={handleCloseBulkActionsBar}
      numberOrRowsSelectedLabel={numberOrRowsSelectedLabel}
      actionButtons={actionButtons}
      ariaLabel='project-tasks-table-bulk-action-bar'
      infoTooltip={infoTooltip}
      disabled={isBulkOperationInProgress}
    />
  );
};

export default BulkActions;
